import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdministratorModalComponent } from '../../../components/administrator-modal/administrator-modal.component';
import { Administrator } from '../../../models/administrator.model';
import { AdministratorService } from '../../../services/administrator.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-administrators-page',
  templateUrl: './administrators-page.component.html',
  styleUrl: './administrators-page.component.scss'
})
export class AdministratorsPageComponent {

  public neighborhoodId?: string;
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public authService: AuthService,
    public administratorService: AdministratorService
  ) {
    
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.administratorService.getAll(
          this.neighborhoodId!
        );
      }
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR create                               */
  /* -------------------------------------------------------------------------- */
  // region create
  async create() {

    const value = prompt('Por favor, ingrese el correo electrónico de usuario');

    if (value) {
      await this.administratorService.create(
        this.neighborhoodId!,
        value
      );
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR delete                               */
  /* -------------------------------------------------------------------------- */
  // region delete
  async delete(
    administrator: Administrator
  ) {

    const flag = confirm('¿Estás seguro de eliminar este administrador?');

    if (flag) {
      await this.administratorService.delete(
        this.neighborhoodId!,
        administrator.uid
      );
    }

  }


  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR open                                */
  /* -------------------------------------------------------------------------- */
  // region open
  open(
    administrator: Administrator
  ) {

    const modalRef = this.modalService.open(
      AdministratorModalComponent
    );

    modalRef.componentInstance.administrator = administrator;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;

  }


  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR update                               */
  /* -------------------------------------------------------------------------- */
  // region update
  async update(
    administrator: Administrator
  ) {

    await this.administratorService.update(
      this.neighborhoodId!,
      administrator.uidAdministrator,
      {
        isOwner: administrator.isOwner,
        paymentsNotification: administrator.paymentsNotification,
        reportsNotification: administrator.reportsNotification
      }
    );

  }

}
